import BaseCardBehavior from './BaseCardBehavior';
import { ICardsState } from '../ICardState';

export default class JokerCardBehavior extends BaseCardBehavior {
    public isPlayable(state: ICardsState) {
        return false;
    }
}
